import { Component, AfterViewInit, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-blog-single',
  templateUrl: './blog-single.component.html',
  styleUrls : ['./blog-single.component.css']
})
export class BlogSingleComponent implements AfterViewInit, OnInit {

  constructor(public shared: SharedService){}

  ngOnInit(): void {
      
  }

  ngAfterViewInit(): void {
    this.shared.includeMainScript();
  }

}
